// extracted by mini-css-extract-plugin
export default {"checked-in":"Flight_checked-in__kkXsH","flagged":"Flight_flagged__9DOY+","contacted":"Flight_contacted__axMAe","no-show":"Flight_no-show__HV-0J"};